export enum natureTravauxTypes {
    LOADING = "LOADING",
    SELECTED_NATURE_TRAVAUX = "SELECTED_NATURE_TRAVAUX",
    GET_NATURE_TRAVAUX_LIST = "GET_NATURE_TRAVAUX_LIST",
}
  
export default natureTravauxTypes;